import React, { Component } from 'react';
import { Button, Table,Card, message } from 'antd';
import {addKey} from "../../utils/utils";
import { route } from '../../routes/routes';
import { getCustomList } from '../../model/customs/requests';
import {dbFields} from '../../model/customs/column';
import storage from '../../utils/storage';
import { configs } from '../../config/config';
class Custom extends Component {
    constructor(props){
        super(props);
        this.state= {
            data:[]
        }


        this.columns = [
            {
                title: dbFields.id.title,
                dataIndex: dbFields.id.key,
                key: dbFields.id.key,
              },
            {
              title: dbFields.name.title,
              dataIndex: dbFields.name.key,
              key: dbFields.name.key,
            },
            {
                title: 'Action',
                dataIndex: '1',
                key: 'action',
                render:(text,record)=>{
                    return (
                        <>
                            <Button
                                shape="round"
                                style={{background: "#851dd6",color:"white" }}
                                type='default' onClick={this.btnFn.bind(this,record)}
                                hidden = {true}
                            >
                                Edit
                            </Button>
                            <Button
                                shape="round"
                                style={{background: "#851dd6",color:"white" }}
                                type='default' onClick={this.handlerAppSetting.bind(this,record)}
                             >
                                app setting
                            </Button>
                        </>
                    )
                }
             
            }
        ]
    }
    componentDidMount(){
        let customsList = [];
        getCustomList().then(res => {
            if(res.data.code === 200){
                customsList = addKey(res.data.data)
                this.setState({
                    data:customsList,
                    isLoaded:true,
                })
            }else{
                console.log(res.data.msg)
                message.warning(res.data.msg)
            }
        }).catch(err=>{
            message.error(err)
        })
    }


    handlerCreate = (e)=>{
        this.props.history.push(route.customs.create)
    }
    handlerAppSetting = record => {
        this.props.history.push(route.customs.app+record.id)
    }
    btnFn = record => {
        this.props.history.push(route.customs.edit + record.id);
    };

    render(){
        return (
            <>
                <Card>
                    <Button 
                     style={{background: "#851dd6",color:"white" }}
                    onClick={this.handlerCreate}>Create</Button>
                </Card>
                <Table 
                     dataSource={ this.state.isLoaded ? this.state.data : [] }
                     columns={this.columns} 
                 />

            </>
        )
    }


}

export default Custom;